import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Stack,
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Collapse,
  IconButton
} from '@mui/material';
import { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Fragment } from "react";

export default function DashboardGanancias({ state }) {
  const [expandedRow, setExpandedRow] = useState(null);
  const [openDetalles, setOpenDetalles] = useState(false);
  const [detallesSeleccionados, setDetallesSeleccionados] = useState([]);

  const ganancias = state.obtenerGananciasDiarias();

  const handleVerDetalles = (detalles) => {
    setDetallesSeleccionados(detalles);
    setOpenDetalles(true);
  };

  const totales = ganancias.reduce(
    (acc, dia) => ({
      compras: acc.compras + dia.compras,
      ventas: acc.ventas + dia.ventas,
      costos: acc.costos + (dia.costos || 0),
      gastos: acc.gastos + (dia.gastos || 0),
      ajustes: acc.ajustes + (dia.ajustes || 0),
      inyecciones: acc.inyecciones + (dia.inyecciones || 0),
      ganancia: acc.ganancia + dia.ganancia
    }),
    { compras: 0, ventas: 0, costos: 0, gastos: 0, ajustes: 0, inyecciones: 0, ganancia: 0 }
  );

  return (
    <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
      {/* HEADER */}
      <Box mb={3}>
        <Typography variant="h5" fontWeight="bold" mb={1}>
          📊 Ganancias Diarias
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Resumen de compras, ventas y utilidades por día
        </Typography>
      </Box>

      {ganancias.length === 0 ? (
        <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
          No hay datos disponibles. Registra ventas para ver el resumen.
        </Typography>
      ) : (
        <>
          {/* TABLA PRINCIPAL */}
          <Box sx={{ overflowX: 'auto' }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: '#ECEFF1' }}>
                    <TableCell sx={{ width: 40 }} />
                    <TableCell sx={{ fontWeight: 'bold' }}>Fecha</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>Compras</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>Ventas</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>Costos</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>Gastos</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>Sobrantes/Faltantes</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>Inyecciones/Retiros</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>Utilidad</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 'bold' }}>Acción</TableCell>
                </TableRow>
                </TableHead>

              <TableBody>
                {ganancias.map((dia, idx) => (
                  <Fragment key={`${dia.fecha}-${idx}`}>
                    <TableRow sx={{ '&:hover': { bgcolor: '#ECEFF1' } }}>
                      <TableCell sx={{ width: 40 }}>
                        <IconButton
                          size="small"
                          onClick={() =>
                            setExpandedRow(expandedRow === idx ? null : idx)
                          }
                        >
                          {expandedRow === idx ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </IconButton>
                      </TableCell>
                      <TableCell>
                        <strong>{dia.fecha}</strong>
                      </TableCell>
                      <TableCell align="right">
                        {dia.compras.toFixed(2)}
                      </TableCell>
                      <TableCell align="right">
                        <strong>{dia.ventas.toFixed(2)}</strong>
                      </TableCell>
                      <TableCell align="right" sx={{ color: '#1565C0', fontWeight: 'bold' }}>
                        -{(dia.costos || 0).toFixed(2)}
                      </TableCell>
                      <TableCell align="right" sx={{ color: '#D84315', fontWeight: 'bold' }}>
                        -{(dia.gastos || 0).toFixed(2)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          color: (dia.ajustes || 0) >= 0 ? '#2E7D32' : '#C62828',
                          fontWeight: 'bold'
                        }}
                      >
                        {(dia.ajustes || 0) >= 0 ? '+' : ''}{(dia.ajustes || 0).toFixed(2)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          color: (dia.ajustes || 0) >= 0 ? '#2E7D32' : '#C62828',
                          fontWeight: 'bold'
                        }}
                      >
                        {(dia.inyecciones || 0) >= 0 ? '+' : ''}{(dia.inyecciones || 0).toFixed(2)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          color: dia.ganancia >= 0 ? '#2E7D32' : '#C62828',
                          fontWeight: 'bold'
                        }}
                      >
                        {dia.ganancia.toFixed(2)}
                      </TableCell>
                      <TableCell align="center">
                        <Button
                          size="small"
                          onClick={() => handleVerDetalles(dia.detalles)}
                        >
                          Detalles
                        </Button>
                      </TableCell>
                    </TableRow>

                    {/* FILA EXPANDIBLE CON DETALLES */}
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        sx={{ paddingBottom: 0, paddingTop: 0 }}
                      >
                        <Collapse in={expandedRow === idx} timeout="auto">
                          <Box sx={{ margin: 1 }}>
                            <Typography
                              variant="subtitle2"
                              fontWeight="bold"
                              mb={1}
                            >
                              Detalle de Ventas
                            </Typography>
                            <Table size="small">
                              <TableHead>
                                <TableRow sx={{ bgcolor: '#ECEFF1' }}>
                                  <TableCell>Producto</TableCell>
                                  <TableCell align="right">Cant.</TableCell>
                                  <TableCell align="right">P. Venta</TableCell>
                                  {/* <TableCell align="right">P. Salida simple</TableCell> */}
                                  <TableCell align="right">P. Costo</TableCell>
                                  <TableCell align="right">Ingreso y Salidas</TableCell>
                                  <TableCell align="right">Costo</TableCell>
                                  <TableCell align="right">Ganancia</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {dia.detalles.map((det, i) => (
                                  <TableRow key={i}>
                                    <TableCell>{det.producto}</TableCell>
                                    <TableCell align="right">
                                      {det.cantidad}
                                    </TableCell>
                                    <TableCell align="right">
                                      {det.precioVenta.toFixed(2)}
                                    </TableCell>
                                    <TableCell align="right">
                                      {det.precioPromedio.toFixed(2)}
                                    </TableCell>
                                    <TableCell align="right">
                                      <strong>
                                        {det.ingreso.toFixed(2)}
                                      </strong>
                                    </TableCell>
                                    <TableCell align="right">
                                      {det.costo.toFixed(2)}
                                    </TableCell>
                                    <TableCell
                                      align="right"
                                      sx={{
                                        color:
                                          det.ganancia >= 0
                                            ? '#2E7D32'
                                            : '#C62828',
                                        fontWeight: 'bold'
                                      }}
                                    >
                                      {det.ganancia.toFixed(2)}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </Fragment>
                ))}

                {/* FILA DE TOTALES */}
                <TableRow sx={{ bgcolor: '#ECEFF1', fontWeight: 'bold' }}>
                  <TableCell colSpan={2}>
                    <strong>TOTALES</strong>
                  </TableCell>
                  <TableCell align="right">
                    <strong>{totales.compras.toFixed(2)}</strong>
                  </TableCell>
                  <TableCell align="right">
                    <strong>{totales.ventas.toFixed(2)}</strong>
                  </TableCell>
                  <TableCell align="right" sx={{ color: '#1565C0' }}>
                    <strong>-{totales.costos.toFixed(2)}</strong>
                  </TableCell>
                  <TableCell align="right" sx={{ color: '#D84315' }}>
                    <strong>-{totales.gastos.toFixed(2)}</strong>
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      color: totales.ajustes >= 0 ? '#2E7D32' : '#C62828',
                      fontWeight: 'bold'
                    }}
                  >
                    <strong>{totales.ajustes >= 0 ? '+' : ''}{totales.ajustes.toFixed(2)}</strong>
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      color: totales.inyecciones >= 0 ? '#2E7D32' : '#C62828',
                      fontWeight: 'bold'
                    }}
                  >
                    <strong>{totales.inyecciones >= 0 ? '+' : ''}{totales.inyecciones.toFixed(2)}</strong>
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      color: totales.ganancia >= 0 ? '#2E7D32' : '#C62828',
                      fontWeight: 'bold'
                    }}
                  >
                    <strong>{totales.ganancia.toFixed(2)}</strong>
                  </TableCell>
                  <TableCell />
                </TableRow>
              </TableBody>
            </Table>
          </Box>

          {/* TARJETAS RESUMEN */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            sx={{ mt: 4 }}
          >
            <Box
              sx={{
                flex: 1,
                p: 2,
                bgcolor: '#E3F2FD',
                borderRadius: 2,
                textAlign: 'center'
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Total Compras
              </Typography>
              <Typography variant="h6" sx={{ color: '#1565C0' }} fontWeight="bold">
                {totales.compras.toFixed(2)}
              </Typography>
            </Box>

            <Box
              sx={{
                flex: 1,
                p: 2,
                bgcolor: '#E8F5E9',
                borderRadius: 2,
                textAlign: 'center'
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Total Ventas
              </Typography>
              <Typography
                variant="h6"
                sx={{ color: '#2E7D32', fontWeight: 'bold' }}
              >
                {totales.ventas.toFixed(2)}
              </Typography>
            </Box>

            <Box
              sx={{
                flex: 1,
                p: 2,
                bgcolor: '#E3F2FD',
                borderRadius: 2,
                textAlign: 'center'
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Total Costos
              </Typography>
              <Typography
                variant="h6"
                sx={{ color: '#1565C0', fontWeight: 'bold' }}
              >
                -{totales.costos.toFixed(2)}
              </Typography>
            </Box>

            <Box
              sx={{
                flex: 1,
                p: 2,
                bgcolor: '#FFF3E0',
                borderRadius: 2,
                textAlign: 'center'
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Total Gastos
              </Typography>
              <Typography
                variant="h6"
                sx={{ color: '#D84315', fontWeight: 'bold' }}
              >
                -{totales.gastos.toFixed(2)}
              </Typography>
            </Box>

            <Box
              sx={{
                flex: 1,
                p: 2,
                bgcolor: totales.ajustes >= 0 ? '#E8F5E9' : '#FFEBEE',
                borderRadius: 2,
                textAlign: 'center'
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Total Sobrantes/Faltantes
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  color: totales.ajustes >= 0 ? '#2E7D32' : '#C62828',
                  fontWeight: 'bold'
                }}
              >
                {totales.ajustes >= 0 ? '+' : ''}{totales.ajustes.toFixed(2)}
              </Typography>
            </Box>

            <Box
              sx={{
                flex: 1,
                p: 2,
                bgcolor: totales.inyecciones >= 0 ? '#E8F5E9' : '#FFEBEE',
                borderRadius: 2,
                textAlign: 'center'
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Total { totales.inyecciones >= 0 ? "Inyecciones" : "Retiros" }
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  color: totales.inyecciones >= 0 ? '#2E7D32' : '#C62828',
                  fontWeight: 'bold'
                }}
              >
                {totales.inyecciones >= 0 ? '+' : ''}{totales.inyecciones.toFixed(2)}
              </Typography>
            </Box>

            <Box
              sx={{
                flex: 1,
                p: 2,
                bgcolor:
                  totales.ganancia >= 0 ? '#E8F5E9' : '#FFEBEE',
                borderRadius: 2,
                textAlign: 'center'
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Total Utilidad
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  color: totales.ganancia >= 0 ? '#2E7D32' : '#C62828',
                  fontWeight: 'bold'
                }}
              >
                {totales.ganancia.toFixed(2)}
              </Typography>
            </Box>
          </Stack>
        </>
      )}

      {/* MODAL DE DETALLES */}
      <Dialog open={openDetalles} onClose={() => setOpenDetalles(false)} maxWidth="md">
        <DialogTitle>Detalle de Ventas</DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: '#ECEFF1' }}>
                <TableCell>Producto</TableCell>
                <TableCell align="right">Cantidad</TableCell>
                <TableCell align="right">P. Venta</TableCell>
                <TableCell align="right">P. Costo</TableCell>
                <TableCell align="right">Ingreso y salidas</TableCell>
                <TableCell align="right">Costo</TableCell>
                <TableCell align="right">Ganancia</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {detallesSeleccionados.map((det, i) => (
                <TableRow key={i}>
                  <TableCell>{det.producto}</TableCell>
                  <TableCell align="right">{det.cantidad}</TableCell>
                  <TableCell align="right">
                    {det.precioVenta.toFixed(2)}
                  </TableCell>
                  <TableCell align="right">
                    {det.precioPromedio.toFixed(2)}
                  </TableCell>
                  <TableCell align="right">
                    <strong>{det.ingreso.toFixed(2)}</strong>
                  </TableCell>
                  <TableCell align="right">
                    {det.costo.toFixed(2)}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      color: det.ganancia >= 0 ? '#2E7D32' : '#C62828',
                      fontWeight: 'bold'
                    }}
                  >
                    {det.ganancia.toFixed(2)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDetalles(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
}
